import { useCallback } from 'react';
import { breakpoints } from '../theme/breakpoints.js';
import { useMedia } from './useMedia.js';

/**
 * A hook for testing if the viewport exceeds a certain breakpoint
 * @param breakpoint The breakpoint to test against
 * @returns {boolean} Whether or not the viewport exceeds the breakpoint
 */
const useGreaterThan = breakpoint => {
  const getBreakpointValue = useCallback(value => Number(value.replace('rem', '')) * 16, []);
  const min = useCallback(breakpoint => `(min-width: ${getBreakpointValue(breakpoints[breakpoint])}px)`, [getBreakpointValue]);
  const hasMatch = useMedia(min(breakpoint), false);
  return hasMatch;
};

export { useGreaterThan };
//# sourceMappingURL=useGreaterThan.js.map
